import {
	Alert,
	Autocomplete,
	Box,
	Button,
	CircularProgress,
	FormControl,
	Grid,
	IconButton,
	InputBase,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Snackbar,
	TextField,
	Tooltip,
	Typography,
	styled,
	tooltipClasses,
} from '@mui/material';

import React, { useEffect, useRef, useState } from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';

import PrintIcon from '@mui/icons-material/Print';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import AddIcon from '@mui/icons-material/Add';

import CloseIcon from '@mui/icons-material/Close';

import {
	LocalizationProvider,
	DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';

import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import './Charges.css';

import {
	createBatches,
	getPracticeStaff,
	editVisitData,
	moveToMaximusExport,
	editStatus,
	getBatches,
	updateBatch,
	postVisitDatalist,
	emrExport,
} from '../../services/api/apiManager';

import { DataGrid } from '@mui/x-data-grid';

import DeleteIcon from '@mui/icons-material/Delete';

import { utils, writeFile } from 'xlsx';

import { useNavigate } from 'react-router';

import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';

export function ChargesList() {
	// useRef

	const [toDate, setToDate] = useState();
	const [fromDate, setFromDate] = useState(null);
	const [openSnackbarDelete, setOpenSnackbarDelete] = useState(false);
	const [openSnackbarStatus, setOpenSnackbarStatus] = useState(false);
	const [openVisitIncludeSnack, setOpenVisitIncludeSnack] = useState({
		snackOpen: false,
		visitExistsIn: '',
	});
	const [openSnackbar, setOpenSnackbar] = useState({
		openSnack: false,
		snackMessage: '',
	});
	const practice_id = localStorage.getItem('practice_id');
	const OSW_id = localStorage.getItem('OSW_id');
	const OID = localStorage.getItem('OID');
	// Update status
	const [updateStatus, setUpdateStatus] = useState('us');
	const [selectedRowID, setSelectedRowID] = useState([]);
	const [movedToMaximused, setMovedToMaximused] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [loading, setLoading] = useState(true);
	const [patientName, setPatientName] = useState('');
	const [status, setStatus] = useState('');
	const [deleteId, setDeleteId] = useState();
	const [batchName, setBatchName] = useState('');
	const [batchAssignedTo, setBatchAssignedTo] = useState('');
	const [validation, setValidation] = useState({
		batchNameInputValidationError: false,
	}); // use this state for validations(in fututre)
	const [allBatches, setAllBatches] = useState([]);
	const [previousBatchSelect, setPreviousBatchSelect] = useState([]);
	const [selectedBatchValues, setSelectedBatchValues] = useState([]);
	const [newBatchInputVisible, setNewBatchInputVisible] = useState(false);
	const [visitDataList, setVisitDataList] = useState([]);

	const [verifyVisits_PrevBatch, setVerifyVisits_PrevBatch] = useState([]);
	const [practice1, setPractice1] = useState([]);
	const [provider, setProvider] = useState('');

	const [loadingProviders, setLoadingProviders] = useState(false);
	const [isProviderLoaded, setIsProviderLoaded] = useState(false);

	// const [providerId, setProviderId] = useState('');
	const navigate = useNavigate();
	const practiceID = localStorage.getItem('practice_id');
	const [apiPage, setApiPage] = useState({
		inPageNumber: 0,
		inRows: 100,
	});
	const convertType = apiPage.inPageNumber.toString();

	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 10,
	});
	const handlePaginationChange = (e) => {
		setPaginationModel({ page: e.page, pageSize: e.pageSize });
		if (
			paginationModel.page != 0 &&
			paginationModel.pageSize === 10 &&
			paginationModel.page % 9 === 0
		) {
			setApiPage((prev) => {
				return {
					inPageNumber: prev.inPageNumber + 1,
					inRows: prev.inRows + 100,
				};
			});
		} else if (
			(paginationModel.page == 0 || paginationModel.page !== 0) &&
			paginationModel.pageSize === 100
		) {
			setApiPage((prev) => {
				return {
					inPageNumber: prev.inPageNumber + 1,
					inRows: prev.inRows + 100,
				};
			});
		} else if (
			paginationModel.page != 0 &&
			paginationModel.pageSize === 25 &&
			paginationModel.page % 3 === 0
		) {
			setApiPage((prev) => {
				return {
					inPageNumber: prev.inPageNumber + 1,
					inRows: prev.inRows + 100,
				};
			});
		} else if (
			paginationModel.page != 0 &&
			paginationModel.pageSize === 50 &&
			paginationModel.page % 1 === 0
		) {
			setApiPage((prev) => {
				return {
					inPageNumber: prev.inPageNumber + 1,
					inRows: prev.inRows + 100,
				};
			});
		}
	};

	const handleChangeStatus = (event) => {
		setStatus(event.target.value);
	};

	// navigate the page and send id
	const sendId = (id, p_id) => {
		navigate('/editCharge', { state: { visit_ID: id, patient_id: p_id } });
	};
	// navigate the page and send id
	const sendIdAddCharge = (id) => {
		navigate('/newCharge', { state: { patient_id: id } });
	};

	const handleChangeUpdateStatus = (event) => {
		setUpdateStatus(event.target.value);
		if (selectedRowID.length > 0 && event.target.value !== 'us') {
			const updatingMultipleStatus = {
				visitIds: selectedRowID.toString(),
				Status: event.target.value,
			};
			changeMultipleVisitStatus(updatingMultipleStatus);
		}
		setSelectedRowID([]);
		setUpdateStatus('us');
	};

	//  body-json of createbatches in swagger
	const createBatchData = {
		BatchName: batchName,
		practice_id: practice_id,
		AssignedTo_id: 1,
		BatchStatus: 'E',
		visit_ids: selectedRowID.toString(),
	};

	const [showAlertStatus, setShowAlertStatus] = useState(false);

	const changeMultipleVisitStatus = async (data) => {
		const resp = await editStatus(data);
		if (resp.status === 200 || resp.status === 201) {
			setPostSucessfully(true);
			// getVisitData();
			getVisitListData(filterData);
		} else {
			setPostSucessfully(false);
		}
		handleClickSnackbarStatus();
	};

	const handleChangeProvider = (event, newValue) => {
		setProvider(event.target.value);
	};
	// Formate date
	const year = new Date(fromDate).getFullYear();
	const month = (new Date(fromDate).getMonth() + 1).toString().padStart(2, '0');
	const day = new Date(fromDate).getDate().toString().padStart(2, '0');
	const formatStartDate = `${year}/${month}/${day}`;
	const year1 = new Date(toDate).getFullYear();
	const month1 = (new Date(toDate).getMonth() + 1).toString().padStart(2, '0');
	const day1 = new Date(toDate).getDate().toString().padStart(2, '0');
	const formatEndDate = `${year1}/${month1}/${day1}`;

	// Modal
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		// these lines are checking the selected visit is exists in any previous batch
		const verify_PrevBatches = allBatches?.map((obj) => ({
			batchName: obj?.BatchName,
			visitIDAdded: obj?.visit_ids,
			visitAlreadyAdded: selectedRowID
				.reduce((acc, x) => acc?.concat(+x), []) //this reduce logic is converting my selectedrows in to integer array so we can check it with values of visits_id of batches
				.some((value) => obj?.visit_ids.includes(value)),
		}));
		setVerifyVisits_PrevBatch(
			verify_PrevBatches?.filter(
				(items) => items?.visitAlreadyAdded !== false
			)[0]?.visitIDAdded
		);
		if (
			verify_PrevBatches?.filter(
				(items) => items?.visitAlreadyAdded !== false
			)[0]?.visitAlreadyAdded === true
		) {
			setOpenVisitIncludeSnack({
				snackOpen: true,
				visitExistsIn: verify_PrevBatches?.filter(
					(items) => items?.visitAlreadyAdded !== false
				)[0]?.batchName,
			});
		} else {
			setOpen(true);
		}
	};

	//move to batch modal close func
	const handleClose = () => {
		setOpen(false);
		setNewBatchInputVisible(false);
	};

	// Modal Delete
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const handleOpenDeleteModal = (dID) => {
		setDeleteId(dID);
		setOpenDeleteModal(true);
	};
	const handleCloseDeleteModal = () => setOpenDeleteModal(false);

	// open snakbar delete
	const handleClickSnackbarDelete = () => {
		setOpenSnackbarDelete(true);
	};
	const handleCloseSnackbarDelete = () => {
		setOpenSnackbarDelete(false);
	};

	// open snakbar delete
	const handleClickSnackbarStatus = () => {
		setOpenSnackbarStatus(true);
	};
	const handleCloseSnackbarStatus = () => {
		setOpenSnackbarStatus(false);
	};

	const [openDate, setOpenDate] = useState(false);
	const handleToggle = () => {
		setOpenDate(!openDate);
	};
	// get data Through Post method
	const filterData = {
		practice_id: practiceID,
		...(patientName && { in_PatientSearch: patientName }),
		...(status && { in_VisitStatus: status }),
		...(fromDate && { in_DateFrom: formatStartDate }),
		...(toDate && { in_DateTo: formatEndDate }),
		...(provider && { in_Provider: provider }),
		in_PageNumber: '0',
		in_Rows: apiPage.inRows.toString(),
	};
	console.log('filtered', filterData);
	const getVisitListData = async (data) => {
		try {
			setLoading(true);
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setVisitDataList(response?.data);
			} else {
				setVisitDataList([]);
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoading(false);
		}
	};

	const getPracticeStaff1 = async () => {
		if (loadingProviders || isProviderLoaded) return;

		setLoadingProviders(true);

		try {
			const response = await getPracticeStaff();

			if (response?.status === 200) {
				setPractice1(response?.data || []);
			} else {
				setPractice1([]);
			}

			setIsProviderLoaded(true);
		} catch (error) {
			setPractice1([]);
		} finally {
			setLoadingProviders(false);
		}
	};

	// get data byid for detele data
	const [showAlertDelete, setShowAlertDelete] = useState(false);
	const handleDeleteUser = async (id, data) => {
		const response = await editVisitData(id, data);
		if (response.status === 200) {
			setPostSucessfully(true);
			getVisitListData(filterData);
		} else {
			setPostSucessfully(false);
		}
		setOpenDeleteModal(false);
		handleClickSnackbarDelete();
	};

	const moveToMaximusData = {
		OSW_id: OSW_id,
		// "OSWPractice_id": OID,
		visitids: selectedRowID.toString(),
		practice_id: practice_id,
	};
	const maximusExport_Func = async (data) => {
		setLoading(true);
		var resp = {};
		if (OSW_id == '1') {
			resp = await moveToMaximusExport(data);
		} else if (OSW_id == '2') {
			resp = await emrExport(data);
		}
		if (resp?.status === 201 || resp?.status === 200) {
			changeMultipleVisitStatus({
				visitIds: selectedRowID.toString(),
				Status: 'B',
			});
			setLoading(false);
			setPostSucessfully(true);
			setOpenSnackbar({
				openSnack: true,
				snackMessage: 'Exported Successfully',
			});
		} else if (resp?.status == undefined) {
			setLoading(false);
			setPostSucessfully(false);
			setOpenSnackbar({ openSnack: true, snackMessage: 'error' });
		}
		getVisitListData(filterData);
		setSelectedRowID([]);
	};

	const getAllBatches = async () => {
		const resp = await getBatches();
		if (resp.status === 200) {
			setAllBatches(resp?.data?.reverse());
		} else {
			setAllBatches([]);
		}
	};
	const handleRowSelect_BatchesGrid = (newSelection) => {
		if (newSelection.length > 0) {
			setPreviousBatchSelect([newSelection[newSelection.length - 1]]); // Only keep the last selected item
			const rowDataOf_ExistingBatches = allBatches?.find(
				(row) => row.id == [newSelection[newSelection.length - 1]] //this will filter the selected row from all batches and we can access the data of that selected row in move to batch modal
			);
			setSelectedBatchValues(
				rowDataOf_ExistingBatches?.visit_ids?.concat(selectedRowID)
			);
			setNewBatchInputVisible(false);
		} else {
			setPreviousBatchSelect([]);
		}
	};

	const handleProviderOpen = () => {
		if (!isProviderLoaded) {
			getPracticeStaff1();
		}
	};
	useEffect(() => {
		getVisitListData(filterData);
		getAllBatches();
	}, [apiPage, status, provider, formatEndDate, formatStartDate, patientName]);
	// formated date
	const formatAdmissionDate = (dateString) => {
		if (!dateString) return null;
		const admissionDate = new Date(dateString);
		const year = admissionDate.getFullYear();
		const month = (admissionDate.getMonth() + 1).toString().padStart(2, '0');
		const day = admissionDate.getDate().toString().padStart(2, '0');
		return `${month}-${day}-${year}`;
	};
	// const filteredVisitData = visitDataList?.filter((item) => {
	// 	const patientNameMatch =
	// 		!search ||
	// 		`${item?.patient?.Lname},${item?.patient?.Fname}`
	// 			.toLowerCase()
	// 			.includes(search.toLowerCase());
	// 	return patientNameMatch;
	// });

	//   Download csv file
	const downloadCSV = (batchname, visitIDS) => {
		const columns = [
			// Column Fields Name here
			[
				'Patient Name',
				'DOB',
				'Primary Payer',
				'Policy Number',
				'Gender',
				'Provider Name',
				'CPT Codes',
				'Dx Codes',
				'Location',
				'Status',
				'Visit Date',
				'Admission date',
				'Referring Physician',
				'Discharge date',
			],
		];

		var workbook = utils?.book_new();
		var worksheet = utils?.json_to_sheet([]);

		utils?.sheet_add_aoa(worksheet, columns);
		// Assuming apiData is an array of objects
		visitDataList
			?.filter((data) => visitIDS?.includes(data?.id))
			?.forEach((item, index) => {
				utils?.sheet_add_json(
					worksheet,
					[
						[
							`${item?.patient?.Lname}, ${item?.patient?.Fname}`,
							`${dayjs(item?.DOB).format('MM/DD/YYYY')}`,
							// `${item?.patient?.patient_insurances[0]?.payer?.Name !== undefined ? item?.patient?.patient_insurances[0]?.payer?.Name : ''}`,
							item?.payer_name,
							item?.PolicyNumber,
							// `${item?.patient?.patient_insurances[0]?.PolicyNumber !== undefined ? item?.patient?.patient_insurances[0]?.PolicyNumber : ''}`,
							`${item?.Gender === 'F' ? 'Female' : item?.patient?.Gender === 'M' ? 'Male' : 'Other'}`,
							// `${item?.practicestaff?.Fname}, ${item?.practicestaff?.Lname}`,
							item?.provider,
							item.visit_cpts
								.map((data) => (data.CPTCode === null ? '' : data.CPTCode))
								.toString(),
							`${item?.Dxcode1 === null ? '' : item?.Dxcode1 + ','}${item?.Dxcode2 === null ? '' : item?.Dxcode2 + ','} ${item?.Dxcode3 === null ? '' : item?.Dxcode3 + ','} ${item?.Dxcode4 === null ? '' : item?.Dxcode4 + ','} ${item?.Dxcode5 === null ? '' : item?.Dxcode5 + ','} ${item?.Dxcode6 === null ? '' : item?.Dxcode6 + ','} ${item?.Dxcode7 === null ? '' : item?.Dxcode7 + ','} ${item?.Dxcode8 === null ? '' : item?.Dxcode8 + ','} ${item?.Dxcode9 === null ? '' : item?.Dxcode9 + ','} ${item?.Dxcode10 === null ? '' : item?.Dxcode10 + ','} ${item?.Dxcode11 === null ? '' : item?.Dxcode11 + ','} ${item?.Dxcode12 === null ? '' : item?.Dxcode12 + ','} `,

							// `${item?.referringPhysician?.Fname}, ${item?.referringPhysician?.Lname}`,
							`${item?.location !== (undefined || null) ? item?.location : ''}`,
							'BILLED',
							// `${item.VisitStatus == 'A' ? 'APPROVED' : item.VisitStatus === null ? 'OTHERS' : item.VisitStatus == 'B' ? 'BILLED' : item.VisitStatus == 'D' ? 'DRAFT' : ''}`,

							dayjs(item?.VisitDate).format('MM/DD/YYYY'),
							dayjs(item?.Admission_date).format('MM/DD/YYYY'),
							item?.referring,
							item?.discharge_date
								? dayjs(item?.discharge_date).format('MM/DD/YYYY')
								: null,
							// item?.referringPhysician?.Fname != undefined
							// 	? item?.referringPhysician?.Fname +
							// 		', ' +
							// 		item?.referringPhysician?.Lname
							// 	: '',
						],
					],
					{ origin: `A${index + 2}`, skipHeader: true }
				);
			});

		utils?.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, `${batchname}_${new Date().toLocaleDateString()}.xlsx`);

		// after exporting visitstatus will be changed to the 'B' Billed
		const updateVisitStatusAfterExport = {
			visitIds: selectedRowID.toString(),
			Status: 'B',
		};
		changeMultipleVisitStatus(updateVisitStatusAfterExport);
	};
	const getDxSummary = (row) =>
		Array.from({ length: 12 }, (_, index) => index + 1)
			.map((index) => {
				const code = row[`Dxcode${index}`];
				const description = row[`Dx${index}Description`];
				return [code, description].filter(Boolean).join(' ');
			})
			.filter(Boolean)
			.join(' | ');
	const getStatusPillStyles = (statusValue) => {
		switch (statusValue) {
			case 'APPROVED':
				return { bg: '#eaf8ef', color: '#0E8F3A', dot: '#0E8F3A' };
			case 'BILLED':
				return { bg: '#fff3e6', color: '#d76a05', dot: '#FD9700' };
			case 'DRAFT':
				return { bg: '#fff7e8', color: '#f0a000', dot: '#FDBA25' };
			case 'REJECTED':
				return { bg: '#fdecec', color: '#d92d20', dot: '#d92d20' };
			case 'Other':
				return { bg: '#fdecec', color: '#d92d20', dot: '#d92d20' };
			default:
				return { bg: '#eef2f7', color: '#53627a', dot: '#8a97ad' };
		}
	};
	// Table column
	const columns = [
		{
			field: 'id',
			headerName: 'Visit ID',
			minWidth: 30,
		},
		{
			field: 'fullName',
			headerName: 'Patient Name',
			minWidth: 140,
			// flex: 1,
			columnMenuButton: {
				color: 'red',
			},
			// sm
			renderCell: (params) => {
				return (
					<Box
						display={'flex'}
						gap={'5px'}
						alignItems={'center'}
						sx={
							selectedRowID //this loogic highlights the visits that already in the previous batches
								.reduce((items, index) => items?.concat(+index), [])
								.filter((items) => verifyVisits_PrevBatch?.includes(items))
								.some((items) => items == params.row.id) && {
								backgroundColor: 'red',
								color: 'wheat',
							}
						}
					>
						<Tooltip
							title={params?.value}
							arrow
							slotProps={{
								popper: {
									modifiers: [
										{
											name: 'offset',
											options: {
												offset: [0, -14],
											},
										},
									],
								},
							}}
							placement="top"
						>
							<Typography
								fontSize={'14px'}
								sx={{
									cursor: 'pointer',
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'nowrap',
									width: 170,
								}}
								onClick={() => {
									sendId(params?.id, params?.row?.patient_id);
								}}
							>
								<u>{params.value}</u>
							</Typography>
						</Tooltip>
					</Box>
				);
			},
		},
		{
			field: 'providerName',
			headerName: 'Provider Name',
			minWidth: 140,
			renderCell: (params) => {
				return (
					<Box>
						<span>
							{params?.row?.providerName == ', '
								? params?.row?.providerName == ''
								: params?.row?.providerName}
						</span>
					</Box>
				);
			},
		},
		{
			field: 'VisitDate',
			headerName: 'Visit Date',
			minWidth: 140,
		},
		{
			field: 'Admission_date',
			headerName: 'Admission date',
			minWidth: 140,
			// flex: 1,
		},
		{
			field: 'Codes',
			headerName: 'Codes',
			// minWidth: 220,
			width: 300,
			// flex: 1,
			renderCell: (params) => {
				const cptCodes =
					params?.row?.Codes?.map((data) => data?.CPTCode)
						.filter(Boolean)
						.join(', ') || '-';
				const dxSummary = getDxSummary(params.row) || '-';
				return (
					<Box
						sx={{
							width: '100%',
							minWidth: 0,
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							gap: '2px',
							overflow: 'hidden',
						}}
					>
						<Tooltip title={cptCodes} arrow placement="top">
							<Typography
								noWrap
								sx={{
									color: '#075AD7',
									fontWeight: 600,
									fontSize: '12px',
									lineHeight: 1.35,
									maxWidth: '100%',
								}}
							>
								{cptCodes}
							</Typography>
						</Tooltip>
						<Tooltip title={dxSummary} arrow placement="top">
							<Typography
								noWrap
								sx={{
									color: '#111827',
									fontWeight: 400,
									fontSize: '12px',
									lineHeight: 1.35,
									maxWidth: '100%',
								}}
							>
								{dxSummary}
							</Typography>
						</Tooltip>
					</Box>
				);
			},
		},
		{
			field: 'location',
			headerName: 'Location',
			minWidth: 150,
			flex: 1,
		},

		{
			field: 'VisitStatus',
			headerName: 'Status',
			width: 100,
			// flex: 1,
			renderCell: (params) => {
				if (!params.value) return null;
				const statusStyle = getStatusPillStyles(params.value);
				return (
					<Box
						sx={{
							display: 'inline-flex',
							alignItems: 'center',
							gap: '6px',
							px: '9px',
							height: 22,
							borderRadius: '999px',
							bgcolor: statusStyle.bg,
							color: statusStyle.color,
							fontSize: '10px',
							fontWeight: 600,
							textTransform: 'uppercase',
							lineHeight: 1,
						}}
					>
						<Box
							component="span"
							sx={{
								width: 5,
								height: 5,
								borderRadius: '50%',
								bgcolor: statusStyle.dot,
								flex: '0 0 auto',
							}}
						/>
						{params.value}
					</Box>
				);
			},
		},
		{
			field: 'batch',
			headerName: 'Batched',
			width: 90,
			// flex: 1,
			renderCell: (params) => {
				return (
					<div
						style={{
							whiteSpace: 'pre-wrap',
							color: `${params.value === 'YES' ? 'green' : 'red'}`,
							fontSize: '13px',
						}}
					>
						{params.value}
					</div>
				);
			},
		},

		{
			field: 'Action',
			headerName: 'Actions',
			width: 90,
			// flex: 1,
			sortable: false,
			align: 'center',
			disableColumnMenu: true,
			renderCell: (params) => {
				return (
					<Box display={'flex'} gap={'5px'}>
						<Tooltip
							title={'Add Charge'}
							arrow
							slotProps={{
								popper: {
									modifiers: [
										{
											name: 'offset',
											options: {
												offset: [0, -14],
											},
										},
									],
								},
							}}
							placement="top"
						>
							<IconButton
								sx={{ ml: '-12px', color: '#3F5D89', cursor: 'pointer' }}
							>
								<AddIcon
									onClick={() => {
										sendIdAddCharge(params?.row?.patient_id);
									}}
									sx={{ fontSize: '18px' }}
								/>
							</IconButton>
						</Tooltip>
						<Tooltip
							title={'Delete Visit'}
							arrow
							slotProps={{
								popper: {
									modifiers: [
										{
											name: 'offset',
											options: {
												offset: [0, -14],
											},
										},
									],
								},
							}}
							placement="top"
						>
							<IconButton
								sx={{ ml: '-12px', color: '#3F5D89', cursor: 'pointer' }}
							>
								<DeleteIcon
									onClick={() => handleOpenDeleteModal(params.id)}
									sx={{ fontSize: '18px' }}
								/>
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];
	// Move to batch datagrid Collumns
	const batchesColumn = [
		{
			field: 'BatchName',
			headerName: 'Batch Name',
			minWidth: 190,
			flex: 1,
			renderCell: (params) => {
				return <span style={{ width: '100%' }}>{params?.row?.BatchName}</span>;
			},
		},
		{
			field: 'visit_ids',
			headerName: 'Charges',
			minWidth: 35,
			renderCell: (params) => {
				return (
					<span
						style={{
							width: '80%',
							color: '#0E4374',
							fontWeight: 'bold',
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						{params?.row?.visit_ids?.length}
					</span>
				);
			},
		},
		{
			field: 'CreatedDate',
			headerName: 'Created Date',
			minWidth: 135,
			// flex: 1,
			renderCell: (params) => {
				return (
					<span style={{ color: 'black' }}>
						{dayjs(params?.row?.CreatedDate).format('MM/DD/YYYY')}
					</span>
				);
			},
		},
	];
	const CustomToolbar = () => {
		const customStyles = `
		  .MuiTablePagination-actions,
		  .MuiTablePagination-displayedRows {
			display: none !important;
		  },
		`;
		const styleElement = document.createElement('style');
		styleElement.innerHTML = customStyles;
		document.head.appendChild(styleElement);
	};

	return (
		<Box
			sx={{
				overflowX: 'hidden',
				width: '100%',
				boxSizing: 'border-box',
				position: 'relative',
				p: '10px 12px',
				bgcolor: '#f6f8fb',
				minHeight: 'calc(100vh - 46px)',
			}}
		>
			{/* status alert */}
			{showAlertStatus && (
				<Alert
					sx={{ zIndex: 1000, width: '100%', position: 'fixed' }}
					icon={
						!showAlertStatus ? (
							<ErrorOutline fontSize="inherit" />
						) : (
							<CheckCircleOutline fontSize="inherit" />
						)
					}
					severity={!postSucessfully ? 'error' : 'success'}
				>
					{!showAlertStatus
						? 'Error not Update Status'
						: 'Successfully Update Status'}
				</Alert>
			)}
			{/* Delete Alert */}
			{showAlertDelete && (
				<Alert
					sx={{ zIndex: 1000, width: '100%', position: 'fixed' }}
					icon={
						!showAlertDelete ? (
							<ErrorOutline fontSize="inherit" />
						) : (
							<CheckCircleOutline fontSize="inherit" />
						)
					}
					severity={!postSucessfully ? 'error' : 'success'}
				>
					{!showAlertDelete ? 'Error not Deleted' : 'Successfully Deleted'}
				</Alert>
			)}
			<Box sx={{ padding: 0 }}>
				<Box
					sx={{
						background: '#fff',
						border: '1px solid #dce6f3',
						borderRadius: '8px',
						p: '10px',
						mb: '10px',
						'& input': {
							fontFamily: 'Poppins',
						},
						'& .MuiInputBase-root': {
							borderRadius: '6px !important',
						},
						'& .MuiStack-root': {
							paddingTop: '0 !important',
							overflow: 'visible',
						},
						'& .MuiFormControl-root': {
							marginTop: '0 !important',
						},
					}}
				>
					{/* Date and select button */}
					<Box>
						<Grid container spacing={1}>
							{/* SearchBar and Searh Button */}
							<Grid item xl={6.8} lg={6.8} md={12} sm={12} xs={12}>
								<Box
									display={'flex'}
									gap={'5px'}
									sx={{
										flexDirection: {
											xs: 'column',
											sm: 'row',
											md: 'row',
											lg: 'row',
										},
										gap: {
											xs: '10px',
											sm: '10px',
											md: '10px',
											lg: '5px',
											xl: '5px',
										},
									}}
								>
									<Box display={'flex'} gap={'5px'}>
										{/* <Box>
											<CustomButton variant="contained">Search</CustomButton>
										</Box> */}
									</Box>
									<Box display={{ xs: 'none', sm: 'flex' }} gap={'5px'}>
										<Box display={'flex'} alignItems={'flex-start'}>
											<Box sx={{ width: '150px' }}>
												<Typography
													sx={{
														fontSize: '12px',
														fontWeight: 600,
														color: '#0a234a',
														mb: '6px',
														lineHeight: 1,
													}}
												>
													Patient
												</Typography>
												<input
													value={patientName}
													onChange={(e) => {
														setPatientName(e.target.value);
													}}
													placeholder="Search..."
													// size="small"
													style={{
														boxShadow: 'none',
														border: '1px solid #d6e2f2',
														borderRadius: '6px',
														height: '40px',
														width: '100%',
														padding: '0 12px',
														fontSize: '13px',
														color: '#122b55',
														boxSizing: 'border-box',
													}}
												/>
											</Box>
										</Box>
									</Box>

									{/* Status, Provider and Search Bar for small screen */}
									<Box display={'flex'} gap={'5px'}>
										{/* Search Bar */}

										<Box display={{ xs: 'flex', sm: 'none' }} gap={'10px'}>
											<Box display={'flex'} alignItems={'center'}>
												<Box>
													<input
														value={patientName}
														onChange={(e) => {
															setPatientName(e.target.value);
														}}
														placeholder="Search..."
														size="small"
														style={{
															boxShadow: 'none',
															border: '1px solid #00000030',
															borderRadius: '5px',
															height: '40px',
															width: '5rem',
															padding: '5px 10px',
														}}
													/>
												</Box>
											</Box>
										</Box>
										{/* Status */}
										<Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
											<Box display={'flex'} alignItems={'center'}>
												<FormControl
													variant="standard"
													sx={{
														minWidth: 80,
														mt: '-16px',
													}}
												>
													<InputLabel
														sx={{
															ml: '10px',
															fontSize: '12px',
															mt: '6px',
														}}
														id="demo-simple-select-standard-label"
													>
														Status
													</InputLabel>
													<Select
														value={status}
														onChange={handleChangeStatus}
														sx={{
															borderLeft: '6px solid #DA8541',
															borderRadius: '7px',
															'&.MuiInput-underline:before': {
																borderBottom: 'none',
															},
															'&.Mui-focused': {
																'&.MuiInput-underline:before': {
																	borderBottom: 'none',
																},
															},
															height: {
																xl: '40px',
																lg: '38px',
																md: '30px',
																xs: '30px',
																sm: '30px',
															},
															width: '80px',
															'& .MuiSelect-select': {
																fontSize: '12px',
																ml: '5px',
															},

															outline: '1px solid #00000026',
														}}
														labelId="demo-simple-select-standard-label"
														id="demo-simple-select-standard"
														label="Location"
														MenuProps={{
															PaperProps: {
																style: {
																	overflowX: 'auto',
																	maxHeight: '300px',
																	width: '130px',
																	overflowY: 'auto',
																	overflowX: 'auto',
																	scrollbarWidth: 'thin',
																	scrollbarColor: 'dark',
																	msOverflowStyle: 'none',
																	WebkitOverflowScrolling: 'touch',
																},
															},
														}}
													>
														<MenuItem sx={{ fontSize: '12px' }} value={''}>
															Clear Filter
														</MenuItem>
														<MenuItem sx={{ fontSize: '12px' }} value={'A'}>
															Approved
														</MenuItem>
														<MenuItem sx={{ fontSize: '12px' }} value={'B'}>
															Billed
														</MenuItem>
														<MenuItem sx={{ fontSize: '12px' }} value={'D'}>
															Draft
														</MenuItem>
														<MenuItem sx={{ fontSize: '12px' }} value={'O'}>
															Other
														</MenuItem>
													</Select>
												</FormControl>
											</Box>
										</Box>
										{/* Provider */}
										<Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
											<Box display={'flex'} alignItems={'center'}>
												<FormControl
													variant="standard"
													sx={{
														minWidth: 80,
														mt: '-16px',
													}}
												>
													<InputLabel
														sx={{
															ml: '10px',
															fontSize: '12px',
															mt: '6px',
														}}
														id="demo-simple-select-standard-label"
													>
														Provider
													</InputLabel>
													<Select
														value={provider}
														onChange={handleChangeProvider}
														sx={{
															borderLeft: '6px solid #DA8541',
															borderRadius: '7px',
															'&.MuiInput-underline:before': {
																borderBottom: 'none',
															},
															'&.Mui-focused': {
																'&.MuiInput-underline:before': {
																	borderBottom: 'none',
																},
															},
															height: {
																xl: '40px',
																lg: '38px',
																md: '30px',
																xs: '30px',
																sm: '30px',
															},
															width: '80px',
															'& .MuiSelect-select': {
																fontSize: '12px',
																ml: '5px',
															},

															outline: '1px solid #00000026',
														}}
														labelId="demo-simple-select-standard-label"
														id="demo-simple-select-standard"
														label="Location"
													>
														<MenuItem value={''} sx={{ fontSize: '14px' }}>
															Clear Filter
														</MenuItem>
														{practice1?.map((item, key) => {
															return (
																<MenuItem
																	key={key}
																	value={item?.id}
																	sx={{ fontSize: '14px' }}
																>
																	{item?.Lname + ', ' + item?.Fname}
																</MenuItem>
															);
														})}
													</Select>
												</FormControl>
											</Box>
										</Box>
									</Box>

									<Box
										display={'flex'}
										gap={'5px'}
										sx={{
											flexDirection: {
												xs: 'row',
											},
											mb: '5px',
										}}
									>
										<Box
											display={'flex'}
											gap={'8px'}
											sx={{
												flexDirection: { xs: 'column', md: 'row' },
												alignItems: { xs: 'start', md: 'center' },
												gap: { md: '10px', xs: '0px' },
											}}
										>
											<Box mb={'3px'} sx={{ width: '150px' }}>
												<Typography
													sx={{
														fontSize: '12px',
														fontWeight: 600,
														color: '#0a234a',
														mb: '6px',
														lineHeight: 1,
													}}
												>
													From Date
												</Typography>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DemoContainer components={['DatePicker']}>
														<DemoItem>
															<MuiDatePicker
																value={fromDate}
																onChange={(newValue) => setFromDate(newValue)}
																size="small"
																// label={'From'}
																sx={{
																	borderRadius: '6px',
																	width: {
																		xl: '100%',
																		lg: '100%',
																		md: '100%',
																		sm: '100%',
																		xs: '100%',
																	},
																	'& .MuiInputBase-root': {
																		height: '40px',
																		fontSize: '13px',
																		color: '#122b55',
																	},
																	'& .MuiOutlinedInput-notchedOutline': {
																		borderColor: '#d6e2f2',
																	},
																}}
																slotProps={{
																	textField: {
																		size: 'small',
																		placeholder: 'MM/DD/YYYY',
																	},
																}}
															/>
														</DemoItem>
													</DemoContainer>
												</LocalizationProvider>
											</Box>
										</Box>
										<Box
											display={'flex'}
											gap={'8px'}
											sx={{
												flexDirection: { xs: 'column', md: 'row' },
												alignItems: { xs: 'start', md: 'center' },
												gap: { md: '10px', xs: '0px' },
											}}
										>
											<Box mb={'3px'} sx={{ width: '150px' }}>
												<Typography
													sx={{
														fontSize: '12px',
														fontWeight: 600,
														color: '#0a234a',
														mb: '6px',
														lineHeight: 1,
													}}
												>
													To
												</Typography>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DemoContainer components={['DatePicker']}>
														<DemoItem>
															<MuiDatePicker
																value={toDate}
																onChange={(newValue) => setToDate(newValue)}
																size="small"
																sx={{
																	borderRadius: '6px',
																	width: {
																		xl: '100%',
																		lg: '100%',
																		md: '100%',
																		sm: '100%',
																		xs: '100%',
																	},
																	'& .MuiInputBase-root': {
																		height: '40px',
																		fontSize: '13px',
																		color: '#122b55',
																	},
																	'& .MuiOutlinedInput-notchedOutline': {
																		borderColor: '#d6e2f2',
																	},
																}}
																slotProps={{
																	textField: {
																		size: 'small',
																		placeholder: 'To',
																	},
																}}
															/>
														</DemoItem>
													</DemoContainer>
												</LocalizationProvider>
											</Box>
										</Box>
									</Box>

									{/* select button Provider for lg  */}
									<Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
										<Box
											display={'flex'}
											alignItems={'flex-start'}
											sx={{ flexDirection: 'column' }}
										>
											<Typography
												sx={{
													fontSize: '12px',
													fontWeight: 600,
													color: '#0a234a',
													mb: '6px',
													lineHeight: 1,
												}}
											>
												Provider
											</Typography>
											{/* <FormControl
												variant="standard"
												sx={{
													minWidth: 80,
													mt: '-16px',
												}}
											>
												<InputLabel
													sx={{
														ml: '10px',
														fontSize: '12px',
														mt: '6px',
													}}
													id="demo-simple-select-standard-label"
												>
													Provider
												</InputLabel>
												<Select
													value={provider}
													onChange={handleChangeProvider}
													sx={{
														borderLeft: '6px solid #DA8541',
														borderRadius: '7px',
														'&.MuiInput-underline:before': {
															borderBottom: 'none',
														},
														'&.Mui-focused': {
															'&.MuiInput-underline:before': {
																borderBottom: 'none',
															},
														},
														height: {
															xl: '40px',
															lg: '38px',
															md: '30px',
															xs: '30px',
															sm: '30px',
														},
														width: '80px',
														'& .MuiSelect-select': {
															fontSize: '12px',
															ml: '5px',
														},

														outline: '1px solid #00000026',
													}}
													labelId="demo-simple-select-standard-label"
													id="demo-simple-select-standard"
													label="Location"
													MenuProps={{
														PaperProps: {
															style: {
																overflowX: 'auto',
																maxHeight: '300px',
																width: '130px',
																overflowY: 'auto',
																overflowX: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem value={''} sx={{ fontSize: '12px' }}>
														Clear Filter
													</MenuItem>
													{practice1?.map((item, key) => {
														return (
															<MenuItem
																key={key}
																value={item?.id}
																sx={{ fontSize: '12px' }}
															>
																{item?.Lname + ', ' + item?.Fname}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl> */}
											{/* <Autocomplete
												size="small"
												id="provider-filter-autocomplete"
												// ✅ Clear Filter option add
												options={[
													{ id: '', label: 'Clear Filter' },
													...(practice1 || []),
												]}
												getOptionLabel={(option) => {
													if (option?.label) return option.label; // Clear Filter
													return option
														? `${option?.Lname}, ${option?.Fname}`
														: '';
												}}
												sx={{
													mt: '-2px',
													width: '120px',
												}}
												// ✅ value mapping
												value={
													[
														{ id: '', label: 'Clear Filter' },
														...(practice1 || []),
													]?.find((item) => item?.id === provider) || null
												}
												// ✅ change handler
												onChange={(event, newValue) => {
													setProvider(newValue ? newValue?.id : '');
												}}
												loading={loadingProviders}
												// ✅ lazy API
												onOpen={handleProviderOpen}
												noOptionsText={
													loadingProviders ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													style: {
														maxHeight: '200px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Provider"
														variant="standard"
														sx={{
															borderLeft: '6px solid #DA8541',
															borderRadius: '7px',
															outline: '1px solid #00000026',

															'& .MuiInputBase-root': {
																fontSize: '12px',
																height: '30px',
																pl: '5px',
															},

															'& .MuiInput-underline:before': {
																borderBottom: 'none',
															},
															'& .MuiInput-underline:after': {
																borderBottom: 'none',
															},
														}}
														InputLabelProps={{
															sx: {
																fontSize: '12px',
																ml: '10px',
																mt: '6px',
															},
														}}
													/>
												)}
											/> */}
											<Autocomplete
												size="small"
												id="provider-filter-autocomplete"
												options={practice1 || []}
												getOptionLabel={(option) =>
													option ? `${option?.Lname}, ${option?.Fname}` : ''
												}
												value={
													practice1?.find((item) => item?.id === provider) ||
													null
												}
												onChange={(event, newValue) => {
													setProvider(newValue ? newValue?.id : '');
												}}
												loading={loadingProviders}
												onOpen={handleProviderOpen}
												noOptionsText={
													loadingProviders ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													style: {
														maxHeight: '300px',
														fontSize: '12px',
													},
												}}
												sx={{
													mt: 0,
													width: '180px',

													'& .MuiInputBase-root': {
														borderRadius: '6px',
														height: '40px',
														fontSize: '13px',
														color: '#122b55',
														pl: '8px',
														border: '1px solid #d6e2f2',
														background: '#fff',
													},

													'& .MuiInput-underline:before': {
														borderBottom: 'none',
													},
													'& .MuiInput-underline:after': {
														borderBottom: 'none',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														placeholder="Select provider"
														variant="outlined"
														InputLabelProps={{
															sx: {
																display: 'none',
															},
														}}
														sx={{
															'& .MuiOutlinedInput-notchedOutline': {
																border: 'none',
															},
															'& legend': {
																display: 'none',
															},
														}}
													/>
												)}
											/>
										</Box>
									</Box>

									{/* Status */}

									<Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
										<Box display={'flex'} alignItems={'flex-start'}>
											<FormControl
												variant="outlined"
												sx={{
													minWidth: 120,
													mt: 0,
												}}
											>
												<Typography
													sx={{
														fontSize: '12px',
														fontWeight: 600,
														color: '#0a234a',
														mb: '6px',
														lineHeight: 1,
													}}
												>
													Status
												</Typography>
												<Select
													value={status}
													onChange={handleChangeStatus}
													displayEmpty
													renderValue={(selected) => {
														if (!selected) return 'Select status';
														if (selected === 'A') return 'Approved';
														if (selected === 'B') return 'Billed';
														if (selected === 'D') return 'Draft';
														if (selected === 'O') return 'Other';
														return selected;
													}}
													sx={{
														borderRadius: '6px',
														border: '1px solid #d6e2f2',
														height: '40px',
														width: '120px',
														'& .MuiSelect-select': {
															fontSize: '13px',
															pl: '12px',
															py: 0,
															minHeight: 'auto !important',
															color: '#122b55',
															display: 'flex',
															alignItems: 'center',
														},
														'& .MuiOutlinedInput-notchedOutline': {
															border: '0 !important',
														},
														'& legend': {
															display: 'none',
														},
														'&:hover': {
															borderColor: '#c8d5e8',
														},
														'&.Mui-focused': {
															borderColor: '#2E68BA',
														},
													}}
													id="demo-simple-select-standard"
													MenuProps={{
														PaperProps: {
															style: {
																overflowX: 'auto',
																maxHeight: '300px',
																width: '130px',
																overflowY: 'auto',
																overflowX: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem sx={{ fontSize: '14px' }} value={''}>
														Clear Filter
													</MenuItem>
													<MenuItem sx={{ fontSize: '14px' }} value={'A'}>
														Approved
													</MenuItem>
													<MenuItem sx={{ fontSize: '14px' }} value={'B'}>
														Billed
													</MenuItem>
													<MenuItem sx={{ fontSize: '14px' }} value={'D'}>
														Draft
													</MenuItem>
													<MenuItem sx={{ fontSize: '14px' }} value={'O'}>
														Other
													</MenuItem>
												</Select>
											</FormControl>
										</Box>
									</Box>

									<Box
										display={'flex'}
										alignItems={'center'}
										sx={{ mt: '9px' }}
									>
										<Button
											onClick={() => {
												setStatus('');
												setProvider('');
												setPatientName('');
												setToDate(null);
												setFromDate(null);
											}}
											variant="contained"
											color="success"
											sx={{
												minWidth: '44px',
												height: '40px',
												padding: 0,
												borderRadius: '6px',
												background: '#2E68BA',
												boxShadow: 'none',
												'&:hover': { background: '#24589f' },
											}}
										>
											<RefreshIcon sx={{ fontSize: 'medium' }} />
										</Button>
									</Box>
								</Box>
							</Grid>
							{/* Button of Move to Batch and Export */}
							<Grid item xl={5.2} lg={5.2} md={12} sm={12} xs={12}>
								<Box
									display={'flex'}
									gap={'5px'}
									alignItems={'center'}
									sx={{
										justifyContent: { lg: 'flex-end', xs: 'flex-start' },
									}}
								>
									<Box display={'flex'} gap={'10px'} alignItems={'center'}>
										<Box display={'flex'} alignItems={'center'}>
											<Box
												// gap={'5px'}
												sx={{
													justifyContent: {
														lg: 'flex-end',
														xs: 'flex-start',
													},
													mt: '18px',
													mr: '3px',
													display: 'flex',
													gap: {
														xs: '10px',
														sm: '10px',
														md: '10px',
														lg: '5px',
														xl: '5px',
													},
												}}
											>
												<Button
													onClick={() => navigate('/newCharge')}
													variant="contained"
													startIcon={<AddIcon />}
													sx={{
														minWidth: '126px',
														height: '40px',
														fontWeight: 600,
														fontFamily: 'Poppins',
														fontSize: '12px',
														backgroundColor: '#2E68BA',
														boxShadow: '0 2px 6px rgba(46, 104, 186, 0.25)',
														textTransform: 'capitalize',
														borderRadius: '6px',
														'&:hover': { backgroundColor: '#24589f' },
													}}
												>
													Add Charge
												</Button>
												<Button
													disabled={selectedRowID.length == 0 ? true : false}
													onClick={handleOpen}
													variant="contained"
													sx={{
														minWidth: '160px',
														height: '40px',
														fontWeight: 600,
														fontFamily: 'Poppins',
														fontSize: '12px',
														backgroundColor: '#eef2f7',
														color: '#7b8797',
														boxShadow: 'none',
														textTransform: 'capitalize',
														borderRadius: '6px',
														'&:hover': { backgroundColor: '#e2e8f0' },
													}}
												>
													Move To Batch & Export
												</Button>
												<Button
													disabled={selectedRowID.length == 0 ? true : false}
													onClick={() => {
														maximusExport_Func(moveToMaximusData);
														setSelectedRowID([]);
													}}
													sx={{
														minWidth: '142px',
														height: '40px',
														fontWeight: 600,
														fontFamily: 'Poppins',
														fontSize: '12px',
														backgroundColor: '#eef2f7',
														color: '#7b8797',
														boxShadow: 'none',
														textTransform: 'capitalize',
														borderRadius: '6px',
														'&:hover': { backgroundColor: '#e2e8f0' },
													}}
													variant="contained"
												>
													{OSW_id == '1'
														? 'Export To Maximus'
														: 'Export to EMR'}
												</Button>

												<Box
													display={'flex'}
													alignItems={'center'}
													sx={{ borderRadius: '7px' }}
												>
													<FormControl
														// variant="standard"
														sx={{
															minWidth: 90,
															borderRadius: '6px',
															bgcolor: '#2E68BA',
															border: 'none',
															color: 'white',
														}}
														size="small"
													>
														<Select
															disabled={
																selectedRowID.length == 0 ? true : false
															}
															value={updateStatus}
															onChange={handleChangeUpdateStatus}
															selected
															sx={{
																color: 'white',
																borderRadius: '5px',
																'& .MuiSelect-icon': {
																	color: 'white',
																},
																fontSize: '11px',
																height: '40px',
																borderRadius: '6px',
															}}
															MenuProps={{
																PaperProps: {
																	style: {
																		overflowX: 'auto',
																		maxHeight: '380px',
																		width: '180px',
																		overflowY: 'auto',
																		overflowX: 'auto',
																		scrollbarWidth: 'thin',
																		scrollbarColor: 'dark',
																		msOverflowStyle: 'none',
																		WebkitOverflowScrolling: 'touch',
																	},
																},
															}}
														>
															<MenuItem value={'us'}>Update Status</MenuItem>
															<MenuItem value={'A'}>Approved</MenuItem>
															<MenuItem value={'B'}>Billed</MenuItem>
															<MenuItem value={'D'}>Draft</MenuItem>
															<MenuItem value={'O'}>Other</MenuItem>
														</Select>
													</FormControl>
												</Box>
												{/* <CustomButton
														variant="contained"
													>
														Export
													</CustomButton> */}
											</Box>
										</Box>
									</Box>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Box>
				<Box>
					<Box
						sx={{
							height: 'calc(100vh - 178px)',
							minHeight: 440,
							overflow: 'hidden',
							background: '#fff',
							border: '1px solid #dce6f3',
							borderRadius: '8px',
						}}
					>
						<DataGrid
							rows={visitDataList?.map((item) => ({
								admissionId: item?.admission_id,
								patient_id: item?.patient_id,
								id: item?.id,
								VisitDate: formatAdmissionDate(item?.VisitDate),
								// providerName: `${item?.practicestaff?.Fname}, ${item?.practicestaff?.Lname}`,
								providerName: item?.provider,
								// providerName: `${item?.practicestaff?.Fname == undefined ? '' : item?.practicestaff?.Fname}${item?.practicestaff?.Fname?.length > 0 ? ', ' : ''} ${item?.practicestaff?.Lname == undefined ? '' : item?.practicestaff?.Lname}`,
								Admission_date: formatAdmissionDate(item?.Admission_date),
								refPhysician: `${item?.referringPhysician?.Fname}, ${item?.referringPhysician?.Lname}`,
								Codes: item.visit_cpts,
								Dxcode1: item.Dxcode1 === null ? '' : item.Dxcode1,
								Dxcode2: item.Dxcode2 === null ? '' : item.Dxcode2,
								Dxcode3: item.Dxcode3 === null ? '' : item.Dxcode3,
								Dxcode4: item.Dxcode4 === null ? '' : item.Dxcode4,
								Dxcode5: item.Dxcode5 === null ? '' : item.Dxcode5,
								Dxcode6: item.Dxcode6 === null ? '' : item.Dxcode6,
								Dxcode7: item.Dxcode7 === null ? '' : item.Dxcode7,
								Dxcode8: item.Dxcode8 === null ? '' : item.Dxcode8,
								Dxcode9: item.Dxcode9 === null ? '' : item.Dxcode9,
								Dxcode10: item.Dxcode10 === null ? '' : item.Dxcode10,
								Dxcode11: item.Dxcode11 === null ? '' : item.Dxcode11,
								Dxcode12: item.Dxcode12 === null ? '' : item.Dxcode12,
								Dx1Description:
									item.Dx1Description === null ? '' : item.Dx1Description,
								Dx2Description:
									item.Dx2Description === null ? '' : item.Dx2Description,
								Dx3Description:
									item.Dx3Description === null ? '' : item.Dx3Description,
								Dx4Description:
									item.Dx4Description === null ? '' : item.Dx4Description,
								Dx5Description:
									item.Dx5Description === null ? '' : item.Dx5Description,
								Dx6Description:
									item.Dx6Description === null ? '' : item.Dx6Description,
								Dx7Description:
									item.Dx7Description === null ? '' : item.Dx7Description,
								Dx8Description:
									item.Dx8Description === null ? '' : item.Dx8Description,
								Dx9Description:
									item.Dx9Description === null ? '' : item.Dx9Description,
								Dx10Description:
									item.Dx10Description === null ? '' : item.Dx10Description,
								Dx11Description:
									item.Dx11Description === null ? '' : item.Dx11Description,
								Dx12Description:
									item.Dx12Description === null ? '' : item.Dx12Description,
								// Codes: `${item?.visit_cpts?.CPTCode}, ${item?.visit_cpts?.Description}, ${item?.Dxcode1} ${item?.Dx1Description}`,
								VisitStatus:
									item?.VisitStatus === 'D'
										? 'DRAFT'
										: item?.VisitStatus === 'A'
											? 'APPROVED'
											: item?.VisitStatus === 'B'
												? 'BILLED'
												: item?.VisitStatus === 'R'
													? 'REJJECTED'
													: item?.VisitStatus === 'O'
														? 'Other'
														: item?.VisitStatus,

								batch: item?.batch_id !== null ? 'YES' : 'NO', //if any visit is exists in any batch ,BatchName or  batch_id will appear otherwise they were null

								location: item?.location,

								fullName: `${item?.patient?.Lname}, ${item?.patient?.Fname}`,
							}))}
							columns={columns}
							paginationModel={paginationModel}
							onPaginationModelChange={handlePaginationChange}
							rowCount={
								visitDataList?.length !== 0 ? visitDataList[0]?.TotalRows : [0]
							}
							pageSizeOptions={[10, 25, 50, 100]}
							checkboxSelection
							onRowSelectionModelChange={(id) => {
								setSelectedRowID(id);
							}}
							rowSelectionModel={selectedRowID} // Bind selection model to selectedRowID
							disableRowSelectionOnClick
							rowHeight={52}
							columnHeaderHeight={35}
							sx={{
								border: 'none',
								color: '#0a234a',
								fontFamily: 'Poppins',
								'& .MuiDataGrid-cell': {
									fontSize: '12px',
									borderBottom: '1px solid #e6edf5',
									outline: 'none !important',
								},
								'& .MuiDataGrid-columnHeader': {
									backgroundColor: '#f4f7fb',
									color: '#45618d',
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '12px',
									textTransform: 'uppercase',
									'.MuiSvgIcon-root': {
										color: '#45618d',
									},
								},
								'& .MuiDataGrid-columnHeaders': {
									borderBottom: '1px solid #dce6f3',
								},
								'& .MuiDataGrid-footerContainer': {
									justifyContent: 'flex-end',
									backgroundColor: '#fff',
									borderTop: '1px solid #dce6f3',
									minHeight: '56px',
									px: 2,
									fontFamily: 'Poppins',
									fontSize: '12px',
									color: '#172d58',
								},
								'& .MuiTablePagination-root': {
									fontFamily: 'Poppins',
									color: '#172d58',
								},
								'& .MuiTablePagination-toolbar': {
									minHeight: '56px',
									gap: '8px',
									px: 0,
								},
								'& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows':
									{
										fontFamily: 'Poppins',
										fontSize: '12px',
										color: '#172d58',
										fontWeight: 600,
									},
								'& .MuiInputBase-root': {
									border: '1px solid #d6e2f2',
									width: '58px',
									height: '34px',
									borderRadius: '6px',
									backgroundColor: 'white',
									fontFamily: 'Poppins',
									fontSize: '12px',
								},
								'& .MuiIconButton-root': {
									color: '#1f66ff',
								},
								'& .MuiTablePagination-actions': {
									display: 'flex',
									gap: '8px',
									ml: 1,
								},
								'& .MuiTablePagination-actions .MuiIconButton-root': {
									width: 34,
									height: 34,
									border: '1px solid #e4ebf6',
									borderRadius: '50%',
									backgroundColor: '#fff',
									color: '#1f66ff',
									p: 0,
								},
								'& .MuiTablePagination-actions .MuiIconButton-root:hover': {
									backgroundColor: '#f4f8ff',
								},
								'& .MuiIconButton-root.Mui-disabled': {
									color: '#b9c7dc',
								},
								'& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled':
									{
										color: '#b9c7dc',
										borderColor: '#e4ebf6',
										backgroundColor: '#fff',
									},
								'& .MuiDataGrid-row:hover': {
									backgroundColor: '#f8fbff',
								},
								'& .MuiCheckbox-root': {
									color: '#55709b',
								},
								'& .MuiDataGrid-virtualScroller': {
									scrollbarWidth: 'thin',
								},
								'& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
									width: '6px',
									height: '6px',
								},
								'& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
									backgroundColor: '#c7d4e8',
									borderRadius: '999px',
								},
							}}
							slotProps={{
								pagination: { labelRowsPerPage: 'Rows per page:' },
							}}
							getRowId={(row) => row.id}
							loading={loading === true ? <CircularProgress /> : null}
						/>
					</Box>
				</Box>
			</Box>
			{/* // )} */}
			{/* SnackBar */}
			<Snackbar
				open={openSnackbar?.openSnack}
				autoHideDuration={2200}
				onClose={() => setOpenSnackbar({ openSnack: false, snackMessage: '' })}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={() =>
						setOpenSnackbar({ openSnack: false, snackMessage: '' })
					}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={() =>
									setOpenSnackbar({ openSnack: false, snackMessage: '' })
								}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{openSnackbar.snackMessage === 'maximus'
						? 'Moved to Maximus'
						: openSnackbar.snackMessage === 'export'
							? 'Move to Batch and Export'
							: openSnackbar.snackMessage === 'update'
								? 'Batch Updated Successfully!'
								: openSnackbar.snackMessage === 'error'
									? 'Error'
									: ''}
				</Alert>
			</Snackbar>
			{/* SnackBar for detele*/}
			<Snackbar
				open={openSnackbarDelete}
				autoHideDuration={2000}
				onClose={handleCloseSnackbarDelete}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbarDelete}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbarDelete}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{!postSucessfully ? 'Error' : 'Delete Charge Successfully!'}
				</Alert>
			</Snackbar>
			{/* SnackBar for Update status*/}
			{
				<Snackbar
					style={openSnackbar.openSnack ? { display: 'none' } : {}}
					open={openSnackbarStatus}
					autoHideDuration={1800}
					onClose={handleCloseSnackbarStatus}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSnackbarStatus}
						severity={!postSucessfully ? 'error' : 'success'}
						variant="filled"
						sx={{
							width: '100%',
							height: '3.5rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={handleCloseSnackbarStatus}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{!postSucessfully ? 'Error' : 'Update Charge Status Successfully!'}
					</Alert>
				</Snackbar>
			}
			{/* snackbar for visitsVerification that they exists in previous batches or not */}
			<Snackbar
				open={openVisitIncludeSnack.snackOpen}
				autoHideDuration={1800}
				onClose={() =>
					setOpenVisitIncludeSnack({ snackOpen: false, visitExistsIn: '' })
				}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={() =>
						setOpenVisitIncludeSnack({ snackOpen: false, visitExistsIn: '' })
					}
					severity={'error'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={() =>
									setOpenVisitIncludeSnack({
										snackOpen: false,
										visitExistsIn: '',
									})
								}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{`Visits Already Includes in "${openVisitIncludeSnack.visitExistsIn}"  Batch`}
				</Alert>
			</Snackbar>
			{/* Modal */}
			<Modal
				open={open}
				// onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={{ ...style, width: '35%' }}>
					<Box display={'flex'} flexDirection={'column'} gap={'1rem'}>
						<Typography
							id="modal-modal-title"
							variant="h5"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Move To Batch
						</Typography>

						<Box>
							<Box
								width={'100%'}
								display={'flex'}
								justifyContent={
									newBatchInputVisible ? 'flex-end' : 'space-between'
								}
							>
								{!newBatchInputVisible ? (
									<>
										<Typography fontWeight={'bold'}>
											Existing Batches:
										</Typography>
										<button
											style={{
												border: 'none',
												width: '150px',
												height: '20px',
												fontSize: '13px',
												backgroundColor: '#ED2828',
												color: 'whitesmoke',
												fontWeight: 500,
												cursor: 'pointer',
												borderRadius: '7px',
											}}
											onClick={() => {
												setSelectedBatchValues([]);
												setPreviousBatchSelect([]);
												setNewBatchInputVisible(true);
											}}
										>
											{' '}
											Add New Batch
										</button>
									</>
								) : (
									<button
										style={{
											border: 'none',
											width: '155px',
											height: '20px',
											fontSize: '13px',
											backgroundColor: '#ED2828',
											color: 'whitesmoke',
											fontWeight: 500,
											cursor: 'pointer',
											borderRadius: '5px',
										}}
										onClick={() => {
											setNewBatchInputVisible(false);
											setBatchName('');
										}}
									>
										{' '}
										Show Existing Batches
									</button>
								)}
							</Box>
							<Box
								width={'100%'}
								height={'300px'}
								bgcolor={'whitesmoke'}
								sx={{
									display: `${newBatchInputVisible ? 'none' : 'block'}`, //byclicking add new batch btn datagridbox will hide
								}}
							>
								<DataGrid
									columns={batchesColumn}
									rows={allBatches}
									disableRowSelectionOnClick
									checkboxSelection
									disableMultipleRowSelection={true}
									rowSelectionModel={previousBatchSelect} //that is used to track that our on select of any row which state is affected
									onRowSelectionModelChange={handleRowSelect_BatchesGrid} //this will work as onchange whenever we select any row what will be happend this function decides
									sx={{
										'& .MuiDataGrid-columnHeader': {
											backgroundColor: '#2081B8',
											color: '#FFFFFF',
											fontFamily: 'Poppins',
											fontWeight: '600',
											fontSize: '15px',
											'.MuiSvgIcon-root': {
												color: 'white',
											},
										},
										'& .MuiDataGrid-footerContainer': {
											display: 'none',
										},
										'& .MuiTablePagination-selectLabel': {
											fontFamily: 'Poppins',
											fontWeight: '500',
											fontSize: '15px',
										},
										'& .MuiInputBase-root': {
											border: '0.5px solid #383838',
											width: '57px',
											height: '30px',
											borderRadius: '10%',
											backgroundColor: 'white',
										},
										'& .MuiDataGrid-row.Mui-selected': {
											backgroundColor: `${selectedBatchValues?.length > 0 ? '#4482a3!important' : 'white'}`,
											color: `${selectedBatchValues?.length > 0 ? 'wheat' : 'black'}`,
										},
									}}
								/>
							</Box>
							<Box
								sx={{
									display: `${newBatchInputVisible ? 'block' : 'none'}`,
								}}
							>
								<Typography fontWeight={'bold'}>Batch Name</Typography>
								<TextField
									sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
									fullWidth
									error={
										validation.batchNameInputValidationError === true
											? true
											: false
									}
									type="text"
									size="small"
									name="batchName"
									value={batchName}
									helperText={
										validation.batchNameInputValidationError === true
											? 'Batch Name Field Should not be Empty!'
											: ''
									}
									onChange={(e) => {
										setBatchName(e.target.value);
										if (batchName !== '') {
											setValidation({ batchNameInputValidationError: false });
										}
									}}
								/>
							</Box>
						</Box>
						<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
							<Button
								variant="contained"
								sx={{ bgcolor: '#ED2828', width: '140px', py: '10px' }}
								onClick={() => {
									handleClose();
									setBatchAssignedTo('');
									setBatchName('');
								}}
							>
								Cancel
							</Button>
							{previousBatchSelect?.length === 0 && newBatchInputVisible ? (
								<Button
									disabled={selectedRowID.length === 0 ? true : false}
									variant="contained"
									sx={{ bgcolor: '#FD7702', width: '200px', py: '10px' }}
									endIcon={<PrintIcon />}
									onClick={async () => {
										if (batchName === '') {
											setValidation({ batchNameInputValidationError: true });
										} else {
											handleClose();
											const result = await createBatches(createBatchData);
											if (result.status == undefined) {
												setPostSucessfully(false);
												setOpenSnackbar({
													openSnack: true,
													snackMessage: 'error',
												});
											} else if (result.status == 201 || result.status == 200) {
												setMovedToMaximused(false);
												setPostSucessfully(true);
												downloadCSV(batchName, createBatchData.visit_ids);
												setOpenSnackbar({
													openSnack: true,
													snackMessage: 'export',
												});
												getAllBatches();
											}
											setBatchName('');
											setSelectedRowID([]);
										}
									}}
								>
									{`Add New Batch`}
								</Button>
							) : previousBatchSelect?.length > 0 ? (
								<Button
									disabled={
										previousBatchSelect?.length === 0
											? true
											: selectedRowID?.length === 0
												? true
												: false
									}
									variant="contained"
									sx={{ bgcolor: '#FD7702', width: '200px', py: '10px' }}
									onClick={async () => {
										handleClose();
										const result = await updateBatch(
											parseInt(previousBatchSelect),
											{
												visit_ids: selectedBatchValues.toString(),
											}
										);
										if (result.status == undefined) {
											setPostSucessfully(false);
											setOpenSnackbar({
												openSnack: true,
												snackMessage: 'error',
											});
										} else if (result.status == 201 || result.status == 200) {
											setPostSucessfully(true);
											setOpenSnackbar({
												openSnack: true,
												snackMessage: 'update',
											});
											getVisitListData(filterData);
											getAllBatches();
										}
										setBatchName('');
										setSelectedRowID([]);
										setPreviousBatchSelect([]);
										setSelectedBatchValues([]);
									}}
								>
									{`Update Batch`}
								</Button>
							) : (
								''
							)}
						</Box>
					</Box>
				</Box>
			</Modal>
			{/* Modal Delete visit */}
			<Modal
				open={openDeleteModal}
				onClose={handleCloseDeleteModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 'min(410px, calc(100vw - 32px))',
						bgcolor: 'background.paper',
						border: '1px solid #dce8f5',
						borderRadius: '10px',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
						outline: 'none',
						overflow: 'hidden',
					}}
				>
					<Box display={'flex'} justifyContent={'flex-end'} sx={{ p: '12px 12px 0' }}>
						<IconButton
							size="small"
							sx={{ color: '#64748b', cursor: 'pointer' }}
							onClick={handleCloseDeleteModal}
						>
							<CloseIcon sx={{ fontSize: '20px' }} />
						</IconButton>
					</Box>
					<Box display={'flex'} flexDirection={'column'} alignItems="center" sx={{ px: 3, pt: 1, pb: 3 }}>
						<Box
							sx={{
								width: 74,
								height: 74,
								borderRadius: '50%',
								background: '#fff1f2',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mb: 2,
							}}
						>
							<Box
								sx={{
									width: 52,
									height: 52,
									borderRadius: '50%',
									background: '#ffe4e6',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<DeleteIcon sx={{ color: '#ef4444', fontSize: '28px' }} />
							</Box>
						</Box>
						<Typography
							id="modal-modal-title"
							align="center"
							component="h2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: 600,
								color: '#1f2937',
								mb: 0.8,
							}}
						>
							Are you sure you want to delete this visit?
						</Typography>
						<Typography
							align="center"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '12px',
								color: '#64748b',
							}}
						>
							This action will mark the visit as deleted.
						</Typography>
					</Box>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: '1fr 1fr',
							gap: 1.5,
							px: 3,
							py: 2.5,
							borderTop: '1px solid #edf2f8',
						}}
					>
						<Button
							variant="contained"
							startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
							sx={{
								height: '40px',
								minWidth: 0,
								borderRadius: '6px',
								border: '1px solid #cfd9e8',
								backgroundColor: '#fff',
								color: '#344054',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: 'none',
								'&:hover': {
									backgroundColor: '#f8fafc',
									borderColor: '#b9c6d8',
									boxShadow: 'none',
								},
							}}
							onClick={handleCloseDeleteModal}
						>
							Cancel
						</Button>
						<Button
							variant="contained"
							startIcon={<CheckCircleOutline sx={{ fontSize: '18px' }} />}
							sx={{
								height: '40px',
								minWidth: 0,
								borderRadius: '6px',
								backgroundColor: '#2f6edb',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
								'&:hover': {
									backgroundColor: '#245fc5',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
								},
							}}
							onClick={() => {
								handleDeleteUser(deleteId, { Deleted: true });
							}}
						>
							Delete
						</Button>
					</Box>
				</Box>
			</Modal>
		</Box>
	);
}
// Custom Stylind
// SearchBar
const Search = styled('div')(({ theme }) => ({
	position: 'relative',
	background: 'white',
	borderRadius: '10px',
	border: '1px solid #00000026',
	borderRadius: theme.shape.borderRadius,
	width: '5rem',
	background: 'white',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
	color: 'inherit',
	width: '100%',
	fontSize: '12px',
	padding: '6px 10px',
}));

// Modal
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 450,
	bgcolor: 'background.paper',
	border: '1px solid #00000026',
	borderRadius: '1rem',
	boxShadow: 24,
	p: '5px 10px 10px 10px',
};
const CustomWidthTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
		backgroundColor: 'gray',
		fontSize: '12px',
	},
});
